<!-- 这个页面时首页显示的内容 -->
<template>
  <div style="display: flex;" class="systemFont2">
    <el-upload
      v-show="
        uploadBtnDisplayFlag &&
          !(
            uploadButtonStyle == 2 &&
            uploadFileList.length > 0 &&
            uploadFileList[0].url
          )
      "
      class="uploadStyle"
      ref="upload"
      action="#"
      :disabled="uploadDisable"
      :before-upload="beforeUploadFile"
      :on-preview="handlePreview"
      :on-change="fileTypeOnChange"
      :file-list="uploadFileList"
      :http-request="myUpload"
      :limit="1"
      :on-exceed="maxUploadNum"
      :accept="'.pdf'"
      :auto-upload="false"
    >
      <!-- 上传的文件： -->
      <div slot="file" slot-scope="{ file }">
        <div v-if="false">
          <a
            class="el-upload-list__item-name"
            @click="downloadFileMethod(file)"
          >
            <i class="el-icon-document"></i>{{ file.name }}
          </a>
          <i
            class="el-icon-close"
            @click="handleRemove(file, uploadFileList)"
          ></i>
        </div>
        <!-- <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" /> -->
      </div>

      <el-button
        v-if="uploadButtonStyle == 0 ? true : false"
        slot="trigger"
        size="small"
        type="primary"
        class="uploadBtnStyle"
        ><img src="../../assets/common/upload.svg"
      /></el-button>
      <el-button
        v-if="uploadButtonStyle == 1 ? true : false"
        :disabled="uploadDisable"
        slot="trigger"
        size="small"
        type="text"
        class="uploadBtnStyle"
        >上传</el-button
      >
    </el-upload>
    <el-popover
      style="margin-left:5px;"
      placement="right-start"
      trigger="hover"
      v-model="popoverVisible"
    >
      <!-- 弹出来的框 -->
      <div>
        <ul class="el-upload-list el-upload-list--text">
          <li
            class="el-upload-list__item"
            v-for="(fileItem, index) in uploadFileList"
            :key="index"
          >
            <a
              class="el-upload-list__item-name"
              @click="downloadFileMethod(fileItem)"
            >
              <i class="el-icon-document"></i>{{ fileItem.name }}
            </a>
            <i
              v-if="uploadDisable == true ? false : uploadBtnDisplayFlag"
              class="el-icon-close"
              style="margin-left:5px"
              @click="handleRemove(fileItem, uploadFileList)"
            ></i>
          </li>
        </ul>
      </div>
      <span
        slot="reference"
        class="systemFont3"
        v-if="uploadButtonStyle != 2 ? true : false"
        >({{ uploadFileList.length }})</span
      >
    </el-popover>
  </div>
</template>

<script>
import qs from "qs";

export default {
  props: {
    uploadFile: {
      type: Object,
      required: true
    },
    uploadButtonStyle: {
      type: Number,
      default: 0
    },
    uploadDisable: {
      type: Boolean,
      default: false
    },
    uploadPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 附件关联代码
      locationCode: "",
      // 上传的文件
      uploadFileList: [],
      // 提交上传文件时的数据
      submitFileData: "",
      // 删除文件的List
      delFileId: [],
      // 上传按钮显示标志
      uploadBtnDisplayFlag: false,
      // 悬浮层可视标志
      popoverVisible: false,
      // 预览可视标志
      dialogVisible: false,
      // 文件url
      imageUrl: "",
      fileChanged: false
    };
  },
  methods: {
    /** 上传超过最大件数后的钩子 */
    maxUploadNum(files, fileList) {
      this.$message.error(
        this.$t("uploadAttachment.maxUploadNumCheck") + "1！"
      );
    },
    /** 上传前钩子 */
    beforeUploadFile(file) {
      console.log(
        "🚀 ~ file: UploadCertificate.vue:153 ~ beforeUploadFile ~ file:",
        file
      );
      if (file.type != "application/pdf") {
        this.$message.error("上传只能是PDF格式!");
        this.uploadFileList = [];
        return false;
      }
      return true;
    },

    /** 手动删除文件 */
    handleRemove(file, uploadFileList) {
      this.fileChanged = true;
      console.log("remove");
      console.log(file);

      // 进行删除操作
      const index = uploadFileList.findIndex(d => d.uid === file.uid);
      // console.log(index);
      if (index !== -1) {
        if (file.status === "success") {
          // 说明是已经上传的文件，要去数据库中删除
          // 往删除数组中添加数据
          this.delFileId.push(file.fileId);
        }
        // 文件列表删除文件
        uploadFileList.splice(index, 1);
      }
      // 当删除后文件列表中不再有文件时
      if (uploadFileList.length == 0) {
        // 关闭popover悬浮层
        this.popoverVisible = false;
      }
    },

    /** 下载文件方法 */
    downloadFileMethod(file) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/common/downLoadFile?path=" + file.url;
      this.$http
        .get(url, { responseType: "blob" })
        .then(response => {
          console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          console.log("返回", response.data);
          if (blob.size == 0) {
            if (!file.fileId) {
              this.$message.error("上传提交后才能预览文件！");
            } else {
              this.$message.error("文件不存在，请联系管理员！");
            }
            loading.close();
          } else {
            // 替换真实文件名
            const fileName = file.name;
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              console.log("download1");
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("文件下载失败，请联系管理员！");
          loading.close();
        });
    },

    /** 点击预览功能 */
    handlePreview(file) {
      this.imageUrl = file.url;
      this.dialogVisible = true;
      console.log("handlePreview");
      console.log(file);
    },

    /** 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用 */
    fileTypeOnChange(file, fileList) {
      this.fileChanged = true;
      if (file.raw.type != "application/pdf") {
        this.$message.error("上传只能是PDF格式!");
        this.uploadFileList = [];
        return;
      }
      if (file.status === "ready") {
        // 判断文件的大小
        const isLt50M = file.size / 1024 / 1024 < 50;
        if (!isLt50M) {
          this.$message.error(this.$t("uploadAttachment.fileSizeCheck"));
          return;
        }
        // 同名文件禁止上传,同时排除自身文件
        const index = fileList.findIndex(
          d => d.name === file.name && d.uid !== file.uid
        );
        if (index === -1) {
          file.url = URL.createObjectURL(file.raw);
          // 放到fileList中
          this.uploadFileList.push(file);
        } else {
          // 重名不能上传
          // 删除最后一个元素
          fileList.pop();
          this.$message.error(this.$t("uploadAttachment.sameFileNameCheck"));
          return;
        }
      }
    },
    async init() {
      this.fileChanged = false;
      // locationCode 关联代码
      this.locationCode = this.uploadFile.locationCode;
      // 上传按钮显示标志
      this.uploadBtnDisplayFlag = this.uploadFile.uploadBtnDisplayFlag;

      // 获取文件列表
      // TODO
      // 如果locationCode是""，返回空的数据列表，解决显示上次上传文件的bug
      if (this.locationCode != "") {
        await this.getFileList();
      } else {
        this.uploadFileList = [];
      }
    },
    // 重写上传方法，该方法上传几个文件就会走几次
    myUpload(file) {
      console.log("myUpload");
      // 将上传的文件放在files数组中
      this.submitFileData.append("addFiles", file.file);
    },

    /** 同步等待上传到服务器 */
    async submitUploadFile() {
      console.log("submitUpload");
      this.submitFileData = new FormData(); // new formData对象
      // 执行myUpload方法，但是不会请求后，只是添加上传文件到List
      this.$refs.upload.submit();
      // 当前用户id
      this.submitFileData.append("userId", localStorage.getItem("userId"));
      // 关联位置代码
      this.submitFileData.append("locationCode", this.uploadFile.locationCode);
      // 创建用户的ID
      this.submitFileData.append("certificateUserId", this.uploadFile.userId);
      this.submitFileData.append("field", this.uploadFile.field);
      this.submitFileData.append("category", this.uploadFile.category);
      this.submitFileData.append("courseNumber", this.uploadFile.courseNumber);
      this.submitFileData.append("dateAndTime", this.uploadFile.dateAndTime);
      this.submitFileData.append("tqsUserId", this.uploadFile.tqsUserId);
      this.submitFileData.append("email", this.uploadFile.email);
      this.submitFileData.append("courseName", this.uploadFile.courseName);
      // 删除的fileID
      this.submitFileData.append("delFiles", this.delFileId);
      // 上传文件标识 -- 99 第三方证书
      this.submitFileData.append("uploadFlag", 99);

      let url = "/api/common/submitUploadFile";
      // const config = { headers: { 'Content-Type': 'multipart/form-data;charset=utf-8' }}
      await this.$http
        .post(url, this.submitFileData)
        .then(res => {
          if (res.data.code === 200) {
            // this.reportPageNo =res.data.data;
            // console.log("上传成功");
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    /** 同步等待获取文件列表 */
    async getFileList() {
      console.log("getFileList");
      let url = "/api/common/getFileList";
      let paramData = {
        // 关联code
        locationCode: this.uploadFile.locationCode,
        uploadFlag: 99
      };
      await this.$http
        .post(url, qs.stringify(paramData))
        .then(res => {
          if (res.data.code === 200) {
            this.uploadFileList = res.data.data;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    /** 返回上传文件列表 */
    getUploadFileList() {
      return this.uploadFileList;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped lang="scss">
/** 整个框 */
.uploadStyle {
  padding: 0px;
  margin-left: 0px;
  width: 40px;
  //  height:17px;
}
/** 上传按钮的框框 */
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  // 里面的加号
  line-height: 80px;
}

/** 上传图片列表 */
.el-upload-list--picture-card .el-upload-list__item {
  padding: 5px 20px 5px 5px;
  margin: 8px 8px 0px 0px;
  width: 82px;
  height: 65px;
}
/** 上传文件列表 */
>>> .el-upload-list--text .el-upload-list__item {
  width: 270px;
  margin-top: 0px;
}
/** remove文件的叉叉 */
.el-upload-list__item .el-icon-close {
  display: unset;
  width: 12px;
}

.img_div {
  border-radius: 10px;
  display: block;
  position: relative;
}
.imgCSS {
  height: 100px;
  width: 100px;
  border-radius: 10px;
  display: block;
  cursor: pointer;
}
.mask {
  position: absolute;
  background: rgba(101, 101, 101, 0.6);
  color: #ffffff;
  opacity: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  pointer-events: none;
}
//弹出框屏幕居中
>>> .el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
  height: 90%;
  // overflow: auto;
}
.mask h3 {
  text-align: center;
  margin-top: 30%;
  pointer-events: auto;
}
.img_div:hover .mask {
  opacity: 1;
}
// 影响全局弹窗遮罩样式,从<style>移入
>>> .body div.v-modal {
  opacity: 0;
}
//弹窗样式
.roll-dialog {
  >>> .el-dialog {
    padding: 3px 30px !important;
    overflow-y: auto !important;
    height: calc(90vh - 140px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/UploadCertificate.vue